import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import SectionMessage, {
  SectionMessageAction,
} from '@atlaskit/section-message';

import { formatDistanceToNow } from 'src/components/pipelines/utils';
import {
  getPipelinePageURL,
  getPullRequestUrl,
} from 'src/components/pipelines/utils/links';
import { useAnalytics } from 'src/components/settings/analytics';
import { getCurrentRepositoryFullSlug } from 'src/selectors/repository-selectors';

import { messages } from '../messages';
import { FixFlakyTestStatus } from '../types';

export const FixFlakyStatus = ({
  pipeline,
  createdAt,
  createdByUser,
  pullRequest,
}: FixFlakyTestStatus) => {
  const { publishLinkClickEvent } = useAnalytics({
    source: 'FixFlakyStatus',
  });
  const { formatMessage } = useIntl();
  const repositoryPath = useSelector(getCurrentRepositoryFullSlug) || '';
  const pipelineUrl = getPipelinePageURL(
    { uuid: pipeline.uuid },
    repositoryPath
  );

  const actions = [
    <SectionMessageAction
      key="buildNumber"
      href={pipelineUrl}
      onClick={() => {
        publishLinkClickEvent('ViewPipeline');
      }}
    >
      {formatMessage(messages.viewPipelineNumber, {
        number: pipeline.buildNumber,
      })}
    </SectionMessageAction>,
    ...(pullRequest?.id
      ? [
          <SectionMessageAction
            key="pullRequest"
            href={getPullRequestUrl(pullRequest.id.toString(), repositoryPath)}
            onClick={() => {
              publishLinkClickEvent('ViewPullRequest');
            }}
          >
            {formatMessage(messages.viewPullRequest)}
          </SectionMessageAction>,
        ]
      : []),
    ...(createdByUser.displayName
      ? [
          <SectionMessageAction key="initiatorUser">
            {formatMessage(messages.initiatorUser, {
              user: createdByUser.displayName,
            })}
          </SectionMessageAction>,
        ]
      : []),
    ...(createdAt
      ? [
          <SectionMessageAction key="date">
            {formatDistanceToNow(createdAt)}
          </SectionMessageAction>,
        ]
      : []),
  ];

  return (
    <SectionMessage actions={actions}>
      {formatMessage(messages.fixFlakyPipelineSuccess, {
        number: pipeline.buildNumber,
      })}
    </SectionMessage>
  );
};
